<template>
  <div class="page-wrapper">
<!--    <v-container fluid>-->

      <v-card>
        <v-tabs
          color="deep-purple accent-4"
          grow
          class="fixed-tabs-bar"
        >
<!--          <v-tab :key="'pending'">Pending</v-tab>-->
          <v-tab :key="'completed'">Kokoro Orders</v-tab>
          <v-tab :key="'vendor'">Vendor Orders</v-tab>
<!--          <v-tab-item :key="'pending'">-->
<!--            <orders-pending/>-->
<!--          </v-tab-item>-->
          <v-tab-item :key="'completed'">
            <orders-completed/>
          </v-tab-item>
          <v-tab-item :key="'vendor'">
            <vendor-orders/>
          </v-tab-item>
        </v-tabs>
      </v-card>
<!--    </v-container>-->
  </div>
</template>

<script>
  import OrdersPending from "./OrdersPending";
  import OrdersCompleted from "./OrdersCompleted";
  import VendorOrders from "./VendorOrders";
  export default {
    name: "Orders",
    components: {OrdersCompleted, VendorOrders},
    data() {
      return {
      }
    },
    created() {

      // Set date for this week;
    },
    mounted() {

    },
    beforeDestroy() {
    },
    computed: {},
    methods: {}
  }
</script>

<style scoped>
  .fixed-tabs-bar > .v-tabs-bar {
    position: -webkit-sticky;
    position: sticky;
    top: 4rem;
    z-index: 2;
  }
</style>



// WEBPACK FOOTER //
// src/components/Orders.vue